export const patientForgotPasswordActions = {
  FORGOT_PASSWORD: {
    REQUEST: 'patient-forgot-password/forgot-password-request',
    SUCCESS: 'patient-forgot-password/forgot-password-success',
    FAILURE: 'patient-forgot-password/forgot-password-failure',
    RESET: 'patient-forgot-password/forgot-password-reset'
  }
};

export const patientResetPasswordActions = {
  RESET_PASSWORD: {
    REQUEST: 'patient-reset-password/reset-password-request',
    SUCCESS: 'patient-reset-password/reset-password-success',
    FAILURE: 'patient-reset-password/reset-password-failure',
    RESET: 'patient-reset-password/reset-password-reset'
  }
};
